import React from 'react';

const WhyChooseUs = () => {
  const features = [
    {
      icon: "https://cdn.acsdev.in/ManaPrint/future-icon-1.svg",
      title: "Satisfaction Guaranteed",
      description: "We stand by every product we print and ship. If it doesn't meet your expectations, we make it right. Your happiness is our top priority, every single time."
    },
    {
      icon: "https://cdn.acsdev.in/ManaPrint/future-icon-2.svg",
      title: "High-Quality Prints",
      description: "Our prints are sharp, vibrant, and made to last. We use premium materials and advanced printing techniques. Every product delivers professional, eye-catching results."
    },
    {
      icon: "https://cdn.acsdev.in/ManaPrint/future-icon-3.svg",
      title: "Bulk & Corporate Orders",
      description: "Ideal for businesses, events, and large group orders. Enjoy consistent quality across every product you order. Take advantage of special discounts for bulk quantities."
    },
    {
      icon: "https://cdn.acsdev.in/ManaPrint/future-icon-4.svg",
      title: "Easy Customization",
      description: "Upload your design and see it instantly previewed on your product. Adjust colors, text, and layouts with a few clicks. Create unique, personalized items exactly how you imagined."
    }
  ];

  return (
    <section className="mt-10 max-md:mt-10" role="region" aria-labelledby="why-choose-us-heading">
      <h2 id="why-choose-us-heading" className="text-6xl leading-none text-center text-neutral-700 font-bold max-md:max-w-full max-md:text-4xl" style={{ fontFamily: 'Gloock, serif' }}>
        Why Choose Us
      </h2>
      <p className="mt-5 text-sm font-medium leading-9 text-center uppercase text-neutral-700 max-md:mt-3 max-md:max-w-full">
        High-quality prints, fast delivery, and effortless customization — everything you need in one place
      </p>

      {/* Responsive Grid Layout */}
      <div className="mt-3 mb-5 w-full max-md:mt-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-7xl mx-auto px-4">
          {features.map((feature, index) => (
            <article
              key={index}
              className="overflow-hidden bg-white rounded-[20px] shadow-[0px_5px_0px_rgba(40,42,47,1)] h-full transition-transform duration-300 hover:transform hover:-translate-y-1"
            >
              <div className="flex flex-col px-4 py-4 h-full border-solid border-[2.5px] border-zinc-800 rounded-[20px]">
                <img
                  src={feature.icon}
                  alt=""
                  className="object-contain aspect-square rounded-[30px] w-[30px] mb-3"
                  role="img"
                  aria-hidden="true"
                />
                <h3 className="text-base font-bold leading-5 text-zinc-800 mb-2">
                  {feature.title}
                </h3>
                <p className="text-xs leading-4 text-gray-500 flex-grow">
                  {feature.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
